var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"23","height":"18","viewBox":"0 0 23 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0 0H23V2H0V0ZM0 8H23V10H0V8ZM23 16H0V18H23V16Z","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }